var _title, _title2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCardStatusCanceled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "190.351 208.973 230.271 160.541",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 190.351,
    y: 208.973,
    width: 230.271,
    height: 160.541,
    rx: 2,
    ry: 2,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(1, 0, 0, 1, 526.00293, -143.878769)"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Card")), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 6,
      fill: "rgba(49, 49, 49, 0.22)"
    },
    x: -331.513,
    y: 381.082,
    width: 202.092,
    height: 128.911,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      strokeWidth: 6,
      fill: "rgb(236, 92, 12)",
      stroke: "rgb(175, 88, 17)"
    },
    x: -323.666,
    y: 374.082,
    width: 202.092,
    height: 128.911,
    rx: 10,
    ry: 10
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "rgb(255, 255, 255)"
    },
    x: -320.505,
    y: 399.616,
    width: 195.51,
    height: 27.321
  }), /*#__PURE__*/React.createElement("rect", {
    x: -306.89,
    y: 457.481,
    width: 63.758,
    height: 23.803,
    rx: 2,
    ry: 2,
    style: {
      fill: "rgb(241, 180, 147)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 8,
      strokeLinecap: "round",
      fill: "none",
      stroke: "rgb(241, 180, 147)"
    },
    d: "M -224.125 463.301 L -161.852 463.291"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(216, 216, 216)",
      strokeWidth: 8,
      strokeLinecap: "round",
      stroke: "rgb(241, 180, 147)"
    },
    d: "M -224.323 476.746 L -189.559 476.736"
  })), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(0.399759, 0, 0, 0.399759, 491.950531, 134.197876)"
  }, _title2 || (_title2 = /*#__PURE__*/React.createElement("title", null, "Status Canceled")), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 6,
      fill: "rgba(49, 49, 49, 0.19)"
    },
    cx: -257.82,
    cy: 265.405,
    rx: 62.801,
    ry: 62.801
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 6,
      fill: "rgb(248, 248, 248)",
      stroke: "rgb(231, 46, 46)"
    },
    cx: -251.454,
    cy: 260.025,
    rx: 62.801,
    ry: 62.801
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      strokeWidth: 7,
      fill: "rgba(231, 46, 46, 0.29)"
    },
    cx: -251.454,
    cy: 260.025,
    rx: 30.75,
    ry: 30.75
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "rgb(231, 46, 46)",
      stroke: "rgb(255, 255, 255)"
    },
    x: -298.697,
    y: 246.556,
    width: 95.526,
    height: 25.535
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCardStatusCanceled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/card-status-canceled.ea1b3a456efa8499c251310abb06efd1.svg";